import { dataArrowCurveDownRightSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowCurveDownRightSolid = /*#__PURE__*/createIcon(dataArrowCurveDownRightSolid)
export default IconArrowCurveDownRightSolid
